import type { ReactNode } from 'react';

export function PageHeader({ title, description, actions }: { title: string; description: string; actions?: ReactNode }) {
  return (
    <div className="page-header">
      <div>
        <p className="eyebrow">QuizPiko Portal</p>
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
      {actions && <div className="header-actions">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, note, tone = 'blue' }: { label: string; value: string | number; note: string; tone?: string }) {
  return (
    <article className={`stat-card tone-${tone}`}>
      <span>{label}</span>
      <strong>{value}</strong>
      <small>{note}</small>
    </article>
  );
}

export function EmptyState({ title, text }: { title: string; text: string }) {
  return (
    <div className="empty-state">
      <img src="/brand/piko-parrot-mascot.png" alt="Piko parrot mascot" />
      <h3>{title}</h3>
      <p>{text}</p>
    </div>
  );
}
